import styled from 'styled-components';

export const ProductGrid = styled.div`
    margin: 0 auto;
    padding: 2.5rem 0; 
    width: 95%;

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
    gap: 3.5rem;
`;

export const SingleProductGrid = styled.div`
    margin: 0 auto;
    padding-top: 4.5rem;

    display: grid;
    --cols: 2;
    grid-template-columns: repeat(var(--cols), 1fr);
    gap: 5rem; 
    @media (max-width: 550px) {
        --cols: 1;
    }
`;